const data = [
  {
    id: 1,
    question: "What's your full name?",
    answer: "Hi I'm Rahul Goswami."
  },
  {
    id: 2,
    question: "What's your age?",
    answer: "I am 23 years old."
  },
  {
    id: 3,
    question: "What's your qualification?",
    answer: "I'm a student of Computer Application. I've done my bachelor's from Gour Mahavidyalaya and currently pursuing MCA from SRM university."
  },
  {
    id: 4,
    question: "What do you need to start on my project?",
    answer: "It will depend on the situation. It mostly depends on the type of the project. But you should have a fair idea of what you want, then we proceed ahead."
  },
  {
    id: 5,
    question: "How long will you take to complete my project?",
    answer: "It depends on the complexity of the project, your avaliable and your payment. Once you have this sorted out, I will deliver you a completion date."
  },
  {
    id: 6,
    question: "Is hosting and domain registration inclusive in your pricing?",
    answer: "No Hosting and Domain is taken care of seperately. You can pay for it or otherwise take care of it on your own"
  },
]

export default data